import { useContext } from "react";
import { SettlementContext } from "contexts";

export default () => useContext(SettlementContext);
